const INITIAL_STATE = { 
    registro: {}, 
    modoTela: 'lista', 
    lista: [], 
    listaTipo: [] 
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
		case 'PONTO_MAPA_MODO_TELA':
            return { ...state,
				modoTela: action.payload.modo,
				registro: action.payload.registro
			};

        case 'PONTO_MAPA_LISTADO':
            return { ...state, lista: action.payload.data };

        case 'PONTO_MAPA_TIPO_SELECT_LISTADO':
			return {
				...state,
				listaTipo: action.payload.data
			};

        default:
            return state;
    }
}
